import { threeItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const insectDegreeDaysCumulativeSinceBiofix:
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_1
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_2
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_3
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_4
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_6
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_7
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_8
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_9
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_10
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_11
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_12
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_13
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_14
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_15
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_16
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_17
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_18
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_19
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_20
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_23
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_24
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_25
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_26
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_27
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_28
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_29
  | typeof valueTypeRenderers.insectDegreeDaysCumulativeSinceBiofix_30 = {
  label: (valueType: string) => {
    const insectId = Number(valueType.split('_').slice(-1)[0])

    return unitConverter.insectDegreeDaysCumulative(null, { insectId: insectId }).titleWithoutUnit()
  },
  block: ({ valueType }) => {
    const insectId = Number(valueType.split('_').slice(-1)[0])

    const baseLabel = threeItemLabel([
      translate.phrases.banyanApp('Degree Days'),
      getInsectNameFromId(insectId),
      `${translate.phrases.banyanApp('Cumulative')} ${unitConverter
        .insectDegreeDaysCumulative(null, { insectId })
        .suffix()}`,
    ])

    return makeNumberRenderer({
      baseLabel,
      render: (n) => unitConverter.insectDegreeDaysCumulative(n, { insectId }).valueAsString(),
    })
  },
}
